module.exports = __webpack_public_path__ + "img/promote_daily_data.c564c238.png";